import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login/index.vue"),
  },
  {
    path: "/password-login",
    name: "password-login",
    component: () => import("@/views/Login/password.vue"),
  },
  {
    path: "/verify",
    name: "verify",
    component: () => import("@/views/Verify/index.vue"),
  },
  {
    path: "/projects",
    name: "projects",
    component: () => import("@/views/Projects/index.vue"),
  },
  {
    path: "/layout",
    name: "/layout",
    redirect: "/dashboard",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/home",
        name: "home",
        meta: {
          title: "لیست ویزیت‌ها",
        },
        // beforeEnter: (to, from, next) => {
        //   if (store.state.userConfig.accessToken !== null) {
        //     if (from.name === "verify") {
        //       window.onpopstate = function () {
        //         history.go(-1);
        //       };
        //     }
        //     next();
        //   }
        // },
        component: () => import("@/views/Home/index.vue"),
      },
      {
        path: "/survey",
        name: "survey",
        meta: {
          title: "لیست پرسشنامه ها",
        },
        component: () => import("@/views/Survey/index.vue"),
      },
      {
        path: "/supervisor",
        name: "supervisor",
        meta: {
          title: "سرکشی ها",
        },
        component: () => import("@/views/Supervisor/index.vue"),
      },
      {
        path: "/profile",
        name: "profile",
        meta: {
          title: "حساب کاربری",
        },
        component: () => import("@/views/Profile/index.vue"),
      },
      
      
    ],
  },
  
  {
    path: "/visitDetail/:id",
    name: "storeDetail",

    component: () => import("@/views/Store/index.vue"),
  },
  {
    path: "/supervisordetail/:id",
    name: "superVisorDetail",

    component: () => import("@/views/Supervisor/superVisorDetail.vue"),
  },
  {
    path: "/supervisorpromoterview/:id",
    name: "superVisorPromoterView",

    component: () => import("@/views/Supervisor/superVisorPromoterView.vue"),
  },
 
  {
    path: "/pickimage/:minImg/:type/:id",
    name: "pickImage",
    meta: {
      title: "بارگزاری تصویر",
    },
    component: () => import("@/views/Image/pickImage.vue"),
  },
  {
    path: "/supervisorimage/:minImg/:type/:id",
    name: "superVisorImage",
    meta: {
      title: "بارگزاری تصویر",
    },
    component: () => import("@/views/Supervisor/superVisorImg.vue"),
  },
  {
    path: "/supervisorimageview/:minImg/:type/:id",
    name: "superVisorImageView",
    meta: {
      title: "مشاهده تصویر",
    },
    component: () => import("@/views/Supervisor/superVisorImgView.vue"),
  },
  
  {
    path: "/generalquestion/:type/:id",
    name: "generalQuestion",
   
    component: () => import("@/views/Question/generalQuestion.vue"),
  },
  {
    path: "/supervisorvisithistory",
    name: "superVisorVisitHistory",
    meta: {
      title: "تاریخچه ویزیت",
    },
    component: () => import("@/views/Supervisor/superVisorVisitHistory.vue"),
  },
  
  {
    path: "/surveydetail/:id",
    name: "surveyDetail",
   
    component: () => import("@/views/Survey/surveyDetail.vue"),
  },
  {
    path: "/surveydetailinvisit/:visit_id/:fill_id",
    name: "surveyDetailInVisit",
    
    component: () => import("@/views/Survey/surveyDetail.vue"),
  },
  {
    path: "/guideline",
    name: "guideLine",
    
    component: () => import("@/views/Guideline/index.vue"),
  },
  {
    path: "/actionplan",
    name: "actionPlan",
    meta: {
      title: "برنامه ی جدید",
    },
    component: () => import("@/views/Supervisor/actionPlan.vue"),
  },
  {
    path: "/visithistory",
    name: "visitHistory",
    meta: {
      title: "تاریخچه ویزیت",
    },
    component: () => import("@/views/visitHistory/index.vue"),
  },
  {
    path: "/surveyquestions/:surveyId/:id",
    name: "surveyQuestions",
   
    component: () => import("@/views/Survey/surveyQuestions.vue"),
  },
  {
    path: "/surveyImage/:surveyId/:id",
    name: "surveyImage",
    meta: {
      title: "بارگزاری تصویر",
    },
    component: () => import("@/views/Survey/surveyImage.vue"),
  },
  {
    path: "/salequestion/:type/:id",
    name: "saleQuestion",
    
    component: () => import("@/views/Question/saleQuestion.vue"),
  },
  {
    path: "/shelfquestion/:type/:id",
    name: "shelfQuestion",
   
    component: () => import("@/views/Question/shelfQuestion.vue"),
  },
  {
    path: "/supervisorquestions/:type/:id",
    name: "superVisiorQuestions",
   
    component: () => import("@/views/Supervisor/superVisiorQuestions.vue"),
  },
  {
    path: "/supervisorquestionsView/:type/:id",
    name: "superVisiorQuestionsView",
   
    component: () => import("@/views/Supervisor/superVisiorQuestionsView.vue"),
  },
  {
    path: "/authentication/uploadimg",
    name: "authenticationPage",
    meta: {
      title: "احراز هویت",
    },
    component: () => import("@/views/Authentication/index.vue"),
  },
  {
    path: "/gifts",
    name: "giftsPage",
    meta: {
      title: "هدایا و ملزومات",
    },
    component: () => import("@/views/Gifts/index.vue"),
  },
  {
    path: "/verifyprofile/:id",
    name: "verifyProfile",
    meta: {
      title: "استعلام",
    },
    component: () => import("@/views/Profile/verifyUser.vue"),
  },
  
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
export default router;
